<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import axios from "axios";
import moment from "moment";
import Vue from "vue";
import "vue-select/dist/vue-select.css";
import Vuetable from "vuetable-2";

import Toasted from "vue-toasted";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";
// Lets Register a Global Error Notification Toast.

Vue.use(Toasted);
/**
 * Departamento component
 */
export default {
  page: {
    title: "Información de la compra",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Loader, Vuetable },
  data() {
    return {
      apiUrl: process.env.VUE_APP_URL,
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      stock: [],
      url: 0,
      iddetalle: 0,
      cantidad: 0,
      idstock: 0,
      idubicacion: 0,
      formPro: {
        no_lote: "",
        no_animales: "",
        fecha_inicio: "",
        tipo_lote: "",
        inversion_comida: "",
        inversion_economica: "",
        state: true,
        credito: true,
        id: 0,
      },
      detalleorden: [],
      fields: [
        
        {
          name: "concentrado.nombre_producto",
          sortField: "concentrado.nombre_producto",
          title: "Nombre Concentrado",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
        {
          name: "lote.no_lote",
          sortField: "lote.no_lote",
          title: "No. Lote",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
        {
          name: "min_fecha",
          sortField: "min_fecha",
          title: "Fecha Inicial",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "15%",
        },
        {
          name: "max_fecha",
          sortField: "max_fecha",
          title: "Fecha Maxima",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
        {
          name: "cantidad_sugerida",
          sortField: "cantidad_sugerida",
          title: "Cantidad Sugerida en LB", 
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
       
       
      ],
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
      },
      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      formget: {
        nombre: "",
        state: true,
      },
      formSub: {
        nombre: "",
        cantidaddepa: "",
        state: true,
        id: 0,
      },
      updating: false,
      title: "Información",
      itemst: [
        {
          text: "Inventario",
          href: "/",
        },
        {
          text: "Información",
          active: true,
        },
      ],
      loadingtable: false,

      showModalL: false, //Loading
      showModalE: false, //Editar
      showModalN: false, //Nuevo registro
      showModalD: false, //Desactivar
      showModalA: false, //Activar
      data: [],
    };
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
    this.detalle();
  },
  watch: {},
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    // FUNCIONES AUXILIARES

    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    showDate(date) {
      return moment(date)
        .locale("es")
        .utc()
        .format("MMM Do YYYY");
    },
    detalle() {
        // console.log(this.$route.params.id)
      axios
        .get(
          process.env.VUE_APP_URL +
            "asignacion_alimento/view?id=" +
            this.$route.params.id,
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
       
          this.detalleorden = response.data.data;
      
        });
    },
    calcularTiempoVidaCerdo(semanasIniciales, fechaIngreso) {
    // Convertir la fecha de ingreso a un objeto Date
            const fechaIngresoDate = new Date(fechaIngreso);
            
            // Obtener la fecha actual
            const fechaActual = new Date();
            
            // Calcular la diferencia en milisegundos entre la fecha actual y la fecha de ingreso
            const diferenciaMilisegundos = fechaActual - fechaIngresoDate;
            
            // Convertir la diferencia de milisegundos a días
            const diferenciaDias = Math.floor(diferenciaMilisegundos / (1000 * 60 * 60 * 24));
            
            // Convertir los días a semanas y días restantes
            const semanasDesdeIngreso = Math.floor(diferenciaDias / 7);
            const diasRestantes = diferenciaDias % 7;
            
            // Calcular las semanas totales de vida
            const semanasTotales = parseInt(semanasIniciales) + semanasDesdeIngreso;
            
            // Retornar el mensaje con el tiempo de vida
            return `${semanasTotales} semanas y ${diasRestantes} días`;
        }
    
    
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    /**
     * Total no. of records
     */
  },
};
</script>
<style>
/* Css para el loading en el modal */

.my-class {
  background: rgba(255, 255, 255, 0);
  color: white;
  border-bottom: 1px solid #f8f8f800;
  border: 1px solid #c02d2d00;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="itemst" />

    <div class="row">
      <div class="col-12">
        >


        <div class="card" style="margin-bottom: 0px;margin-top: 0px;">
          <div class="card-body" style=" padding-top: 0px;padding-bottom: 0px;">
            <div class="">
              <div class="row justify-content-center">
                <div class="">
                  <div class="text-center" >
                    <div class=""></div>
                    <h4 >Asignacion de Alimento</h4>
                  </div>
                  <hr />
                  <div class="card" style="margin-bottom: 0px;margin-top: 0px;">
                    <div class="card-body" style=" padding-top: 0px;padding-bottom: 0px;">
                      <div class="text-center">
                        <div class="row">
                          <div class="col-sm-8 ">
                            <h4 class="card-title">Detalles de Asignacion de alimento</h4>
                          </div>

                          <div class="col-sm-4">
                            <div>
                              <router-link
                                :to="{
                                  name: 'AsignacionAlimento',
                                }"
                              >
                                <b-button
                                  variant="outline-primary"
                                  type="button"
                                  class="btn btn-rounded mb-1 me-2"
                                >
                                  <i class="mdi mdi-arrow-collapse-left"></i>
                                  Regresar
                                </b-button>
                              </router-link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
              </div>
            </div>
          </div>
        </div>

        <div class="card" style="margin-bottom: 0px;margin-top: 0px;">
          <div class="card-body" style=" padding-top: 0px;padding-bottom: 0px;">
            <h4 class="card-title">Listado de cerdos</h4>
            <div class="row ">
              <div class="col-sm-12 col-md-12">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center"> </label>
                </div>
              </div>

              <!-- End search -->
            </div>
            <!-- Table -->
            <Loader :loading="loadingtable">
              <vuetable
                v-if="detalleorden.length > 0"
                ref="vuetable"
                class="table-divided table-responsive order-with-arrow"
                :css="css.table"
                :api-mode="false"
                :fields="fields"
                :data="detalleorden"
              >
                <!-- <div slot="opciones" slot-scope="props">
                  <b-button-group class="mt-4 mt-md-0">
                    <b-button
                      tabindex="0"
                      v-if="props.rowData.estado_traslado == true"
                      v-b-tooltip.focus
                      title="Autorizar  Ingreso"
                      variant="success default"
                      @click="
                        onActionClicked('desactivate-item', props.rowData)
                      "
                    >
                      <i class="bx bxs-add-to-queue check-nav-icon"></i>
                    </b-button>
                  </b-button-group>
                  
                </div> -->
              
                <div slot="precio_compra" slot-scope="props">
                  {{ money(props.rowData.cerdo.precio_compra) }}
                </div>
                <div slot="peso_ingreso" slot-scope="props">
                  {{ (props.rowData.cerdo.peso_ingreso) + ' LB' }}
                </div>
                <div slot="fecha_ingreso" slot-scope="props">
                  {{showDate (props.rowData.cerdo.fecha_ingreso) }}
                </div>
                <div slot="vida_actual" slot-scope="props">
                  {{calcularTiempoVidaCerdo (props.rowData.cerdo.semanas, props.rowData.cerdo.fecha_ingreso) }}
                </div>
                <!-- <div slot="ubicacion" slot-scope="props">
                  {{ props.rowData.inventario_producto.bodega.nombre_bodega }}
                </div> -->
              </vuetable>
            </Loader>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
